// @flow

import EventEmitter from 'eventemitter3';

export default class Store extends EventEmitter {
  all() {
    throw "not implemented";
  }

  on(events: string, callback: Function): mixed {
    return events.split(" ").map((event) => super.on(event, callback));
  }

  off(events: string, callback: Function): mixed {
    return events.split(" ").map((event) => super.off(event, callback));
  }
}
